// extracted by mini-css-extract-plugin
module.exports = {"success":"styles_success__2ocro","success__title":"styles_success__title__10OPA","success__text":"styles_success__text__3_hHd","success__button":"styles_success__button__2toUl"};